import React from 'react';

import Navbar from 'react-bootstrap/Navbar';
import { NavLink } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';

// redux
import { useDispatch } from 'react-redux'

// selector
import { useSelector } from 'react-redux'

// redux functions
import { USER_CREATE, userCreate } from '../redux/duck/user-duck'

// history
import { useHistory } from "react-router-dom";

const HeaderPublicComponent = () =>{

  const user = useSelector(state => state.default.user);

  const history = useHistory();

  // dispatch
  const dispatch = useDispatch()

  const logout = () => {
    localStorage.removeItem('token');
    history.push('/');

    dispatch({ type: USER_CREATE });

    dispatch(userCreate({
        token: null
    }));
  };

    return <Navbar bg="light" expand="lg">
    <Navbar.Brand  className="nav-logo">
      <NavLink to="/">Agua Nuestra</NavLink>
    </Navbar.Brand>
    <Navbar.Toggle aria-controls="basic-navbar-nav" />
    {
      (user && user.token) &&
      <Nav  className="ml-auto">
        <button type="button" className="btn btn-danger btn-sm" onClick={logout}>Logout</button>
      </Nav>
    }
    
  </Navbar>
};

export default HeaderPublicComponent;
